export class Global {


    // used to select Inverter Strings form Canvas
    public static stringName: string = "String";
    // used to select panels form Canvas
    public static panelsOnRoof: string = "panelsOnRoof";
    // used to select non usable areas form Canvas
    public static nonUsableArea: string = "nonUsableArea";
    public static fence: string = "Obstruction";


    public static nRoofZoom: number = 1;
    //Farben
    public static colFence: number = 0x555555;
    public static colFenceHover: number = 0xffffff;
    public static colFenceSelected: number = 0xffffff;
    public static colModul: number = 0x222222;
    public static colModulHover: number = 0xffffff;
    public static colModulSelected: number = 0x00FFFF;
    public static colModulInvalid: number = 0xFF0000;
    //Konva js using below colors
    public static colCanTilEver: string = "#ffcc00";
    public static colInvalidPanels: string = "#ff0000";
    public static colDach: string = "#ce5e60";
    public static colDachF: string = "#a93335";
    public static colDachG: string = "#c53f42";
    public static uiBeamColor: string = "#333333";
    public static colE10: number = 0xce5e60;
    //Toleranz für Modulabstand
    public static nModAbstTol: number = 1;//0.5;
    public static toggleBoundaryArea: boolean = false;
    public static cantileverValid: boolean = true;
    public static formatVersion(iVersion: number): String {
        var sRet: String;
        sRet = ((iVersion & 0x00ff0000) >> 16).toString();
        sRet += "." + ((iVersion & 0x0000ff00) >> 8).toString();
        sRet += "." + (iVersion & 0x000000ff).toString();
        return sRet;
    }

    static canRoof: any = {
        width: 0, // Canvas availble width
        height: 0, // Canvas availble height
        roofWidth: 0,
        roofHeight: 0,
        scaleX: 1,
        scaleY: 1,
        stepX: 0,
        stepY: 0,
    };

    static dragDropModules: any = {
        rows: 1,
        columns: 1,
        portrait: true,
        allowPanelonRoof: false
    }
    // static colDach: string = "#ce5e60";
    // static colDachF: string = "#a93335";
    // static colDachG: string = "#c53f42";
    // static uiBeamColor: string = "#333333";

    static panelRows: any[] = [];
    static roofObstructions: any[] = [];
    static hgroups: any = [];
    static aHProfile: any = [];
    static hookExtended: any = [];
    static iRoofShape: any = null;

    static getKW(panels: number, pdc: number) {
        return (panels * pdc / 1000);
    }

    static stringTree: any = [];
    static canvasImg: any = "";
    static panelOverviewImage: any = "";
    static panelSubframeImage: any = "";
    static panelSubframeProfileCutImage: any = "";
    static googleMapImage: any = "";
    static stringAssoc: number[] = [];
    static inverterStrings: any = [];
    static OverviewImage: any = "";
    static SubGenImage: any = [];
    static roofWidth: number = 0;
    static roofHeight: number = 0;
    static panelClientRectDetailsForElipseError: any = null;
    static singlePanelSize: any = {};
    static cutlistGroup: any = [];

    static pointIsInRange(p: number, q: number, obj: any): boolean {
        if (obj && obj.getAttrs()) {
            var x = obj.getAttrs().x;
            var y = obj.getAttrs().y;
            var w = obj.getAttrs().width;
            var h = obj.getAttrs().height;
            if (p >= x && p <= x + w && q >= y && q <= y + h) {
                return true;
            }
        }
        return false;
    }

    static convertToLocalNumber(num : any): any {
        if(window.localStorage.getItem("lng") == 'de'){
             return new Number(num).toLocaleString("de-DE");
        }
        return num;
    }

};

export function setFence(data: any){
    Global.roofObstructions = data;
}